import axios from 'axios';
import config from '../config/config';
import { getAuthHeaders } from '../utils/authUtils'; // Import the utility function

export const fetchCompanies = async () => {
  const response = await axios.get(`${config.apiBaseUrl}/api/companies`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const saveCompany = async (company) => {
  const headers = getAuthHeaders();
  if (company.companyId) {
    await axios.put(`${config.apiBaseUrl}/api/companies/${company.companyId}`, company, { headers });
  } else {
    await axios.post(`${config.apiBaseUrl}/api/companies`, company, { headers });
  }
};

export const deleteCompany = async (companyId) => {
  const headers = getAuthHeaders();
  await axios.delete(`${config.apiBaseUrl}/api/companies/${companyId}`, { headers });
};